import { useState } from 'react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import { Sheet, SheetBody, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui/sheet'
import type { Location } from '@/types/api'
import { LocationForm } from './location-form'

export function LocationSheet({
  open,
  onOpenChange,
  location,
  onSaved,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  location?: Location
  onSaved?: (location: Location) => void
}) {
  const [pending, setPending] = useState(false)
  const formId = 'location-form'
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="sm:max-w-xl">
        <SheetHeader>
          <SheetTitle>{location ? `Edit ${location.name}` : 'New location'}</SheetTitle>
          <SheetDescription>{location ? 'Update address, timezone and contact details.' : 'Locations group displays by physical site and set their local timezone.'}</SheetDescription>
        </SheetHeader>
        <SheetBody>
          {open && (
            <LocationForm
              key={location?.id ?? 'new'}
              location={location}
              formId={formId}
              hideActions
              onPendingChange={setPending}
              onSuccess={(saved) => {
                toast.success(location ? 'Location updated' : 'Location created', { description: saved.name })
                onOpenChange(false)
                onSaved?.(saved)
              }}
            />
          )}
        </SheetBody>
        <SheetFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button type="submit" form={formId} loading={pending}>
            {location ? 'Save changes' : 'Create location'}
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
